module.exports = __webpack_public_path__ + "img/menu.eb839404.svg";